import React from 'react';
import { Text } from '@moda/om';
import { ReturnPolicyCopy } from '../../ReturnPolicyInformation/ReturnPolicyCopy';
import { RETURN_POLICY_CODE_TO_KEY } from '../../../constants/returnPolicyCodeToKey';

interface Props {
  isReturnable: boolean;
  promoCodeApplied: boolean;
  returnPolicy: number;
}

export const OrderItemDetailsReturnPolicyMessage: React.FC<Props> = ({
  isReturnable,
  returnPolicy,
  promoCodeApplied
}) => {
  if (isReturnable) {
    return (
      <Text>
        <ReturnPolicyCopy
          returnPolicy={
            RETURN_POLICY_CODE_TO_KEY[returnPolicy as keyof typeof RETURN_POLICY_CODE_TO_KEY]
          }
          promoCodeApplied={promoCodeApplied}
        />
      </Text>
    );
  }

  return null;
};
